export async function renderPrescriptionPdf(element, filename) {
  if (!element) throw new Error('Prescription document unavailable');
  await document.fonts.ready;
  const host = document.createElement('div');
  host.style.cssText = 'position:absolute;left:-10000px;top:0;width:720px;background:white;color:#111827;';
  const clone = element.cloneNode(true);
  host.appendChild(clone); document.body.appendChild(host);
  try {
    await Promise.all([...clone.querySelectorAll('img')].map(img => img.decode()));
    const { default: html2pdf } = await import('html2pdf.js');
    return await html2pdf().set({filename, margin:[8,8,8,8],
      pagebreak:{mode:['css','legacy'],avoid:['.print-avoid-break']},
      html2canvas:{scale:2,useCORS:true,backgroundColor:'#ffffff'},
      image:{type:'png',quality:1}, jsPDF:{unit:'mm',format:'a4',orientation:'portrait'}
    }).from(clone).outputPdf('blob');
  } finally { host.remove(); }
}
export function downloadPrescriptionPdf(blob, filename) {
  const url=URL.createObjectURL(blob); const a=document.createElement('a');
  a.href=url;a.download=filename;a.click();setTimeout(()=>URL.revokeObjectURL(url),60000);
}
export function printPrescriptionPdf(blob, frame) {
  const url=URL.createObjectURL(blob);
  frame.onload=()=>{frame.contentWindow.focus();frame.contentWindow.print();};
  frame.src=url;
  // Kept until the user leaves this document so the native print viewer can read it.
  frame.dataset.pdfUrl=url;
}
